import React, { useContext, useEffect, useState } from "react";
import "./Market_News.css"; // renamed from Market_News.css
import Section_Header_Bar from "../../common_components/section_header_bar/Section_Header_Bar";
import Inner_Footer_Text_Component from "../../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import { getAllCompany } from "../../../utils/apis/common/Common";
import { MarketNews } from "../../../utils/apis/master/Master";
import { Context } from "../../../utils/context";

const Market_News = () => {
  const { IMG_URL } = useContext(Context);
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [showMoreText, setShowMoreText] = useState(null); // expanded news index
  const [activeFaq, setActiveFaq] = useState(null); // expanded FAQ index
  const [searchQuery, setSearchQuery] = useState("");

  const [category, setCategory] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);

  const getCompany = async () => {
    const res = await getAllCompany();
    if (res?.success) {
      setCategory(res.data?.data);
    }
  };

  const [marketNews, setMarketNews] = useState([]);
  const getMarketNews = async (id) => {
    const res = await MarketNews(id);
    if (res?.success) {
      setMarketNews(res.data?.data || []);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  useEffect(() => {
    if (category.length > 0) {
      const firstId = category[0]?.id;
      setActiveCategory(firstId);
      getMarketNews(firstId);
    }
  }, [category]);

  const truncateText = (text, wordLimit) => {
    const words = text.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "...";
    }
    return text;
  };

  // All FAQs
  const faqs = [
    {
      question: "What is cryptocurrency?",
      answer:
        "Cryptocurrency is a type of digital money that uses blockchain technology to secure transactions and operate without a central authority like a bank.",
    },
    {
      question: "Is cryptocurrency legal?",
      answer:
        "Cryptocurrency regulations vary by country. In many regions, crypto is legal to own and trade, but users should check local laws and tax requirements.",
    },
    {
      question: "Why is my deposit taking longer than expected?",
      answer:
        "Cryptocurrency deposits depend on blockchain network confirmations and processing time. While most deposits are credited quickly, delays may occasionally occur due to network conditions.\n\n**Deposit Processing Time:**\n• Minimum: 1 minute\n• Maximum: Up to 24 hours\n\n**Common reasons for delay include:**\n• High blockchain network traffic\n• Low network (gas) fees selected during the transaction\n• Pending or incomplete blockchain confirmations\n• Incorrect or missing transaction information\n\nIf your deposit has not been credited after 24 hours, please contact our support team with your Transaction ID (TXID) and Screenshot for further assistance.",
    },
    {
      question: "Why is my withdrawal taking longer than expected?",
      answer:
        "Withdrawal processing depends on blockchain network confirmations and our internal security checks. While most withdrawals are processed quickly, delays may occasionally occur due to network conditions.\n\n**Withdrawal Processing Time:**\n• Minimum: 1 minute\n• Maximum: Up to 7 days\n\n**Common reasons for delay include:**\n• High blockchain network traffic\n• Low network (gas) fees selected during the transaction\n• Pending or incomplete blockchain confirmations\n• Incorrect or missing transaction information\n\nIf your withdrawal has not been credited after 7 days, please contact our support team with your Transaction ID (TXID) and Screenshot for further assistance.",
    },
    {
      question: "How may I buy crypto?",
      answer:
        "There are many platforms and services available online that sell cryptocurrency. However, exchange rates and fees may vary from platform to platform, and some sellers may offer crypto at higher prices.\n\nIf you are unable to purchase a specific cryptocurrency directly through other platforms, you may contact any of the trusted Telegram partners listed below. which are recognized by our platform:\n\nThese partners are trusted by our website and can assist you in purchasing crypto",
    },
    {
      question: "Do I need to pay taxes on crypto?",
      answer:
        "Tax rules vary by country. You may be required to report crypto transactions and gains. Consult a tax professional for guidance.",
    },
  ];

  const filteredFaqs = faqs.filter((faq) =>
    faq.question.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <section className="help-centre-page">
      <div className="header-section">
        <Section_Header_Bar />
      </div>

      <h1 className="page-title">Help Centre</h1>

      <div className="help-container">
        {/* Search Bar */}
        <div className="search-bar-wrapper">
          <input
            type="text"
            placeholder="Search for help..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="help-search-input"
          />
          <span className="search-icon">🔍</span>
        </div>

        {/* FAQs Accordion */}
        <div className="faq-section">
          <h2 className="section-heading">Frequently Asked Questions</h2>

          {filteredFaqs.length > 0 ? (
            filteredFaqs.map((faq, index) => (
              <div
                key={index}
                className={`faq-card ${activeFaq === index ? "expanded" : ""}`}
                onClick={() => setActiveFaq(activeFaq === index ? null : index)}
              >
                <div className="faq-question">
                  <h3>{faq.question}</h3>
                  <span className="faq-toggle">
                    {activeFaq === index ? "−" : "+"}
                  </span>
                </div>

                <div className="faq-answer">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: faq.answer.replace(/\n/g, "<br />"),
                    }}
                  />
                </div>
              </div>
            ))
          ) : (
            <div className="no-results">
              <p>No matching FAQs found.</p>
              <p>Contact support for further assistance.</p>
            </div>
          )}
        </div>

        <div className="bg-slate-950 mb-3 border border-slate-800 rounded-xl p-5 sm:p-6 shadow-lg">
  <p className="text-lg font-semibold text-white mb-3">
    Want to buy crypto without Binance?
  </p>

  <p className="text-slate-300 mb-4">
    Here are some trusted partners recognized by the website:
  </p>

  <div className="space-y-2 mb-6">
    <a href="https://t.me/seedcryptel" target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:text-cyan-300 block">
      → t.me/seedcryptel
    </a>
    <a href="https://t.me/DtLimit5M" target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:text-cyan-300 block">
      → t.me/DtLimit5M
    </a>
  </div>

  <div className="p-4 bg-red-950/50 border border-red-900/50 rounded-lg text-red-200 text-sm">
    <strong>Never send money first!</strong> Only pay after you see the cryptocurrency in your wallet.
  </div>
</div>

        {/* Support Contact */}
        <div className="support-contact-box ">
          <h3>Still Have Questions?</h3>
          
           <p className="mt-4"> If your question is not listed here, please contact support:{" "}</p>
            <p className="support-email -mt-3">support@falana.com</p>
         
        </div>

        {/* Latest Updates (original news feed) */}
        {/* {marketNews.length > 0 && (
          <div className="updates-section">
            <h2 className="section-heading">Latest Updates</h2>
            <div className="news-grid">
              {marketNews.map((item, index) => {
                const isExpanded = showMoreText === index;
                const description = isExpanded
                  ? item?.description
                  : truncateText(item?.description || "", 200);

                return (
                  <div key={index} className="news-card">
                    <div className="news-image">
                      <img src={IMG_URL + item?.image} alt={item?.title} />
                    </div>
                    <div className="news-content">
                      <div className="news-meta">
                        <span className="news-author">{item?.name}</span>
                        <span className="news-date">
                          {new Date(item?.createdAt).toLocaleDateString("en-GB")}
                        </span>
                      </div>
                      <h3 className="news-title">{item?.title}</h3>
                      <div className="news-description">
                        {htmlToReactParser.parse(description)}
                      </div>
                      {item?.description?.split(" ").length > 200 && (
                        <button
                          className="read-more-btn"
                          onClick={() => setShowMoreText(isExpanded ? null : index)}
                        >
                          {isExpanded ? "Show Less" : "Read More"}
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )} */}
      </div>

      <div className="footer-section">
        <Inner_Footer_Text_Component />
      </div>
    </section>
  );
};

export default Market_News;